<template>
    <!-- 登录 忘记密码 -->
    <div class="login-warp" v-if="login.show">
        <!-- 登录 -->
        <div class="login-box">
            <a href="javascript:void(0);" class="close" @click="login.show=false"><img src="/static/images/close.png" class="db"></a>
            <div class="login" v-if="login.type === 1">
                <div class="clearfix">
                    <h2 class="color-blue fwl fl">用户登录</h2>
                    <span class="color-red fr">{{login.loginTips}}</span>
                </div>
                <div class="item">
                    <i class="icons user-icon"></i>
                    <input class="input-text" type="text" v-model="username" placeholder="请输入用户名"/>
                </div>
                <div class="item">
                    <i class="icons lock-icon"></i>
                    <input class="input-text" type="password" v-model="password" placeholder="请输入密码" @keyup.enter="enterLogin();"/>
                </div>
                <div class="mt10 clearfix">
                    <label class="checkbox-box fl">
                        <label class="checkbox-warp fl" :class="loginRemember === '1' ? 'curr' : ''">
                            <input name="" type="checkbox" v-model="loginRemember" class="checkbox" value="1"> 
                            <i class="icons checkbox-icon"></i>
                        </label>
                        <span class="color-666">记住密码</span>
                    </label>
                    <a class="checkbox-box color-blue fr" href="javascript:void(0);" @click="loginDataEmpty(2);">忘记密码</a>
                </div>
                <div class="item">
                    <button class="btn btn-blue" @click="enterLogin();">登录</button>
                </div>
            </div>
            <!-- 忘记密码 -->
            <div class="login" v-if="login.type === 2">
                <div class="clearfix">
                    <h2 class="color-blue fwl fl">忘记密码</h2>
                    <span class="color-red fr">{{login.loginTips}}</span>
                </div>
                <div class="item">
                    <input class="input-text" v-model="phone" type="text" placeholder="请输入手机号"/>
                </div>
                <div class="item yzm clearfix">
                    <input class="input-text fl" v-model="yzmCode" maxlength="4" type="text" placeholder="请输入验证码"/>
                    <button class="btn btn-border fr" v-if="codeShow" @click="getVerificationCode();">获取验证码</button>
                    <button class="btn btn-border disabled fr" v-if="!codeShow">已发送 {{codeTime}}s</button>
                </div>
                <div class="mt10 clearfix">
                    <a class="checkbox-box color-blue" href="javascript:void(0);" @click="loginDataEmpty(1);">账号密码登录</a>
                </div>
                <div class="item">
                    <button class="btn btn-blue" :disabled="btnDisabled" @click="checkCode();">{{btnDisabled != true ? '确认' : '请稍后...'}}</button>
                </div>
            </div>
            <!-- 修改密码 -->
            <div class="login" v-if="login.type === 3">
                <div class="clearfix">
                    <h2 class="color-blue fwl fl">忘记密码</h2>
                    <span class="color-red fr">{{login.loginTips}}</span>
                </div>
                <div class="item">
                    <input class="input-text" v-model="newPassword" type="password" placeholder="请输入新密码"/>
                </div>
                <div class="item clearfix">
                    <input class="input-text fl" v-model="enterNewPassword" type="password" placeholder="请在次输入新密码"/>
                </div>
                <div class="mt10 clearfix">
                    <a class="checkbox-box color-blue" href="javascript:void(0);" @click="loginDataEmpty(1);">账号密码登录</a>
                </div>
                <div class="item">
                    <button class="btn btn-blue" :disabled="btnDisabled" @click="resetPwd();">{{btnDisabled != true ? '确认' : '请稍后...'}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            login:{
                show:false,
                loginTips:'111',//错误提示
                type:1,//1是登录2是忘记密码
            },//显示登录框
            btnDisabled:false,//防止重复提交
            loginRemember:'1',//记住密码
            username:'',//账户
            password:'',//密码
            sign:'',//修改密码凭证
            // templateColor:'green',//模板类别
            codeTime:60,//验证码文字
            codeShow:true,//控制倒计时按钮
            phone:'',//手机号码
            yzmCode:'',//验证码
            newPassword:'',//新密码
            enterNewPassword:''//确认新密码
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            // that.getBeliel();
        }) 
    },
    created() {
		
    },
    methods: {
        // 登录
        enterLogin () {
            let that = this;
            let datas = {
                username:that.username,
                password:that.password,
                loginRemember:that.loginRemember
            }
            if(that.username == '' || that.password == ''){
                that.login.loginTips = '请输入用户名或密码';
                return;
            }
            that.$parent.loadModal(true,'正在登录...');
            that.$api.post('user/login/login',{data:datas},r =>{
                that.$parent.showLoad = false;
                let code = r.code;
                if(code === 10000){//成功
                    let token = r.data;
                    if(that.loginRemember === '1'){//记住密码
                        that.$utils.saveCookie('xiaohuozi',token,7);
                    }else{
                       sessionStorage.setItem('xiaohuozi', token); 
                    }
                    that.login.show = false;
                    that.$parent.getCompany("/analysis/yuYingGather");
                }else if(code === -100){          
                    that.login.loginTips = r.msg;

                }
            })
        },
        // 登录切换数据重置
        loginDataEmpty (type) {
            let that = this;
            this.login.type = type;
            this.login.loginTips = '';
            if(type === 1){//切换登录
                that.username = '';
                that.password = '';
            }else if(type === 2){//切换忘记密码
                
                that.phone = '';
                that.yzmCode = '';
            }else if(type === 3){//切换输入新密码
                that.newPassword = '';
                that.enterNewPassword = '';
            }
        },
        // 获取验证码
        getVerificationCode () {
            let that = this;
            let time = that.codeTime;
            let phone = that.phone;
            if(that.codeShow){
                if(!(/^1[3456789]\d{9}$/.test(phone))){ 
                    that.login.loginTips = '手机号码有误';
                    return; 
                } 
                that.$api.post('user/login/send-code',{mobile:phone},r =>{
                    let code = r.code;
                    if(code === 10000){//成功
                        // that.yzmCode = r.data.code;  
                    }else if(code === -100){
                        that.login.loginTips = r.msg;
                    }
                })
            }
            that.codeShow = false;
            if(time === 0){
                that.codeTime = 60;
                that.codeShow = true;
                return;
            }
            time--;
            that.codeTime = time;
            that.codeTips = '已发送'+time+'s';
            setTimeout(() => {
                that.getVerificationCode(time);
            }, 1000);
        },
        // 验证验证码
        checkCode () {
            let that = this;
            let phone = that.phone;
            let yzmCode = that.yzmCode;
            that.btnDisabled = true;
            that.$api.post('user/login/check-code',{mobile:phone,code:yzmCode},r =>{
                let code = r.code;
                that.btnDisabled = false;
                if(code === 10000){//成功
                    that.sign = r.data.sign;  
                    that.loginDataEmpty(3);  
                }else if(code === -100){
                    that.login.loginTips = r.msg;
                }
            })
        },
        // 确认修改密码
        resetPwd () {
            let that = this;
            let new1 = that.newPassword;
            let new2 = that.enterNewPassword;
            if(new1 == ''){ 
                that.login.loginTips = '请输入新密码';
                return; 
            }else if(new2 == ''){
                that.login.loginTips = '请再次输入新密码';
                return; 
            }else if(new1.length < 8 || new1.length > 16 || new2.length < 8 || new2.length > 16){
                that.login.loginTips = '密码长度8-16位';
                return; 
            }else if(new2 != new1){
                that.login.loginTips = '2次密码不一致';
                return; 
            }
            that.btnDisabled = true;
            that.$api.post('user/login/reset-pwd',{sign:that.sign,pwd:new1},r =>{
                that.btnDisabled = false;
                let code = r.code;
                if(code === 10000){//成功
                    that.loginDataEmpty(1);
                    that.$utils.alertText('修改成功');
                }else if(code === -100){
                    that.login.loginTips = r.msg;
                }
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/index/login.vue